import styled from 'styled-components';

const Button = styled.button`
  box-sizing: border-box;
  outline: none;
  border: 2px solid white;
  padding: 0.7em 3em;
  font-size: 18px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: bold;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
  background: ${(props) => (props.secondary ? 'none' : 'white')};
  color: ${(props) => (props.secondary ? 'white' : props.theme.primary)};
  transition: all 0.3s ease-in-out;
  color: ${(props) => (props.pink ? 'white' : props.theme.primary)};
  background: ${(props) => (props.pink ? props.theme.primary : 'white')};

  &:hover {
    transform: translate3d(0, -5px, 0);
    box-shadow: 0 9px 6px 0 rgba(0, 0, 0, 0.15);
  }
  &:disabled,
  &[disabled] {
    border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
    cursor: not-allowed;
  }
  &:hover:disabled {
    transform: translate3d(0, 0, 0);
  }
  @media (max-width: 1000px) {
    display: ${(props) => (props.hideOnMobile ? 'none' : 'inherit')};
  }
`;

export default Button;
